import { EMAILS_CHANNELS } from 'components/Wizards/WizardsV3/constants'
import { ChannelType } from 'components/CampaignCreationModal/Types'

// Get unique channels from all categories
export const EMAIL_BLOCK_CHANNELS = [...new Set(Object.values(EMAILS_CHANNELS).flat())] as const
export type EmailChannel = ChannelType

export const shouldShowEmailBlockWrapper = (channel: EmailChannel | null) => {
  return channel && EMAIL_BLOCK_CHANNELS.includes(channel)
}
